/// <reference path="../../src/types.d.ts" />
export const defaultFilterableOptions = {
    dateFilter: undefined,
    filters: []
};
